module.exports = __webpack_public_path__ + "img/img_information_01.b47d42eb.png";